import React from 'react';
import { Text } from '@/components/Typography';
import { StatusRisk } from './constants';
import * as S from './styles';

interface ContentProps {
	children?: number;
	isCardResult?: boolean;
}

export function Content({ children = 0, isCardResult = false }: Readonly<ContentProps>) {
	function handleRiskColor(score: number): StatusRisk {
		if (score > 5) {
			return StatusRisk.HIGH_RISK;
		}

		if (score > 0) {
			return StatusRisk.ACCEPTABLE;
		}

		return StatusRisk.DEFAULT;
	}

	const statusRisk: number = handleRiskColor(children);

	return (
		<S.ContentContainer span={24} $status={statusRisk} $isResult={isCardResult}>
			<Text>{children ?? '-'}</Text>
		</S.ContentContainer>
	);
}
